import { PERMISSION } from "../../../rbac/permissions";
export var PERMISSIONLISTING_EVENT;
(function (PERMISSIONLISTING_EVENT) {
    PERMISSIONLISTING_EVENT["REFRESH"] = "PermissionEvent.Refresh";
})(PERMISSIONLISTING_EVENT || (PERMISSIONLISTING_EVENT = {}));
export var HIDDEN_PERMISSIONS = [PERMISSION.SUPER_ADMIN];
